/**
 * Tenant scope — which tenant the user is currently operating in.
 *
 * Hydrated from /api/v1/auth/me on app boot (Header). User can switch via
 * the tenant dropdown in the top bar; the new tenant_id is persisted to
 * localStorage and sent as the X-Compass-Tenant header on every request.
 */
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface TenantInfo {
  id: string
  slug: string
  name: string
  is_superuser_view?: boolean  // true when the current user is_superuser
}

interface TenantState {
  currentTenant: TenantInfo | null
  availableTenants: TenantInfo[]
  isSuperuser: boolean

  setCurrentTenant: (t: TenantInfo | null) => void
  setAvailableTenants: (ts: TenantInfo[]) => void
  setIsSuperuser: (v: boolean) => void
}

export const useTenantStore = create<TenantState>()(
  persist(
    (set) => ({
      currentTenant: null,
      availableTenants: [],
      isSuperuser: false,
      setCurrentTenant: (currentTenant) => set({ currentTenant }),
      setAvailableTenants: (availableTenants) => set({ availableTenants }),
      setIsSuperuser: (isSuperuser) => set({ isSuperuser }),
    }),
    {
      name: 'compass.tenant',
      partialize: (s) => ({ currentTenant: s.currentTenant }),
    },
  ),
)
